import { useState, useEffect, useRef } from 'react'
// import { useLocation } from '@reach/router'

// import { navigate } from 'gatsby'
// import { getLocale, localizedPath } from '@plugins/bw-i18next/utils'

const useGetArticles = (path: string, numPerPage = 30) => {
  const didMount = useRef(false)
  const [didMountState, setDidMountState] = useState(false)

  // const { hash } = useLocation()
  const { hash } = typeof window !== 'undefined' ? window.location : { hash: '' }
  const hashParams = hash.substring(1).split(',')

  const [numVisible, setNumVisible] = useState(
    Number(hashParams.find((param: string) => param.startsWith('show:'))?.substring(5)) || numPerPage
  )

  const [selectedTag, setSelectedTag] = useState(
    hashParams.find((param: string) => param.startsWith('tag:'))?.substring(4) || ''
  )

  useEffect(() => {
    if (!didMount.current) {
      didMount.current = true
      setDidMountState(true)
      return // return early if initial render
    }

    const params = []
    if (selectedTag) {
      params.push(`tag:${selectedTag}`)
    }
    if (numVisible > numPerPage) {
      params.push(`show:${numVisible}`)
    }
    const newHash = params.length > 0 ? `#${params.join(',')}` : ''
    if (newHash !== hash) {
      window.history.pushState({}, '', `${window.location.pathname}${newHash}`)
    }
  }, [selectedTag, numVisible])

  return {
    numVisible,
    setNumVisible,
    numPerPage,
    selectedTag,
    setSelectedTag,
    didMountState,
  }
}

export default useGetArticles
